export function disableBeforeunload() {
  window.onpagehide = null;
  window.onbeforeunload = null;
}
